import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getOrgs, getUsersByOrg, getDevicesByOrg, getRegistriesByOrg } from 'Data/api';
import useGlobalState from 'Hooks/useGlobalState';
import CircularLoader from 'Components/Loaders/CircularLoader';
import { Card, CardHeader, CardContent, Container, Grid } from '@mui/material'; // Container, Grid, Typography, 
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';

const initOrgTree = (data) => {
	data.sort((a, b) => a.name.localeCompare(b.name));
	data.forEach(org => {
		org.suborgs = data.filter(suborg => {
			return suborg.org.uuid === org.uuid
		});
	});
	return data;
}

const AdminOrganisation = () => {
	const { uuid } = useParams();
	const navigate = useNavigate();

	const [globalState, dispatch] = useGlobalState();
	const { orgs } = globalState;
	// const [orgs, setOrgs] = useState([]);
	const [myOrg, setMyOrg] = useState(null);
	const [viewList, setViewList] = useState([]);
	// const [myUsers, setMyUsers] = useState(null);
	const [viewListUsers, setViewListUsers] = useState([]);
	const [viewListBuildings, setViewListBuildings] = useState([]);
	// const [viewListUsers, setViewListUsers] = useState([]);

	// const [usersearch, setUsersearch] = useState('');
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		dispatch({ adminTitle: 'Organisation' });
		const fetchData = async () => {
			setLoading(true);
			let orgs = await getOrgs().then(data => {
				// console.log('Admin - useEffect - orgs', data);
			return initOrgTree(data);
			});
			console.log('Admin - useEffect - orgs', orgs);
			dispatch({ orgs: orgs });

			console.log('Admin - useEffect', orgs);
			let selectedOrg = orgs.filter(org => {
				return org.uuid === uuid
			});
			setMyOrg(selectedOrg[0]);
			setViewList(selectedOrg[0].suborgs);
			// console.log('Admin - useEffect', selectedOrg);

			// Get users
			let users = await getUsersByOrg(selectedOrg[0].uuid);
			// console.log('Admin - useEffect - users', users);
			// setMyUsers(users);
			setViewListUsers(users);
			// Get devices
			let devices = await getDevicesByOrg(selectedOrg[0].uuid);
			console.log('Admin - useEffect - devices', devices);

			// Get buildings
			let buildings = await getRegistriesByOrg(selectedOrg[0].uuid);
			buildings.forEach(building => {
				// console.log('Admin - useEffect - building', building);
				building.devices = devices.filter(device => {
					// console.log('Admin - useEffect - device', device, building);
					return device.registry.uuid === building.uuid
				});
			});
			// console.log('Admin - useEffect - buildings', buildings);
			setViewListBuildings(buildings);
		}
		fetchData();
		setLoading(false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			console.log('AdminOrganisation - useEffect - uuid', uuid);
			let selectedOrg = orgs.filter(org => {
				return org.uuid === uuid
			});
			setMyOrg(selectedOrg[0]);
			// if (selectedOrg[0].suborgs === undefined) {
			// 	selectedOrg[0].suborgs = [];
			// }
			setViewList(selectedOrg[0].suborgs);

			// Get users
			let users = await getUsersByOrg(selectedOrg[0].uuid);
			// console.log('Admin - useEffect - users', users);
			// setMyUsers(users);
			setViewListUsers(users);
			// Get devices
			let devices = await getDevicesByOrg(selectedOrg[0].uuid);
			console.log('Admin - useEffect - devices', devices);

			// Get buildings
			let buildings = await getRegistriesByOrg(selectedOrg[0].uuid);
			buildings.forEach(building => {
				// console.log('Admin - useEffect - building', building);
				building.devices = devices.filter(device => {
					// console.log('Admin - useEffect - device', device, building);
					return device.registry.uuid === building.uuid
				});
			});
			// console.log('Admin - useEffect - buildings', buildings);
			setViewListBuildings(buildings);
		}
		fetchData();
		setLoading(false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [uuid]);

	return (!loading ?
		<Container maxWidth="lg" style={{ padding: '20px', marginBottom: '100px' }}>
			<Card>
				<CardHeader title={myOrg && myOrg.name} 
					action={
						<>
							<AddIcon onClick={() => navigate("/admin/organisation/" + myOrg.uuid + "/add")} style={{ cursor: 'pointer', marginRight: '10px' }} />
							<EditIcon onClick={() => navigate("/admin/organisation/" + myOrg.uuid + "/edit")} style={{ cursor: 'pointer', marginRight: '10px' }} />
							{/* <DeleteIcon onClick={() => navigate("/admin/organisation/" + myOrg.uuid + "/delete")} style={{ cursor: 'pointer' }} /> */}
						</>
					}
				/>
				<CardContent>
					{/* <Grid container spacing={2} style={{ marginTop: '0px' }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							{myOrg && myOrg.name}
						</Grid>
					</Grid> */}
					{/* <Grid container spacing={2} style={{ marginTop: '20px' }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<TextField
								style={{ width: '100%' }}
								autoFocus
								id="search"
								label="Organisations søgning"
								variant="outlined"
								onChange={(event) => setUsersearch(event.target.value)}
							/>
						</Grid>
					</Grid> */}
					<Grid container spacing={2} style={{ marginTop: '20px' }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							Dine organisationer:
						</Grid>
						{viewList.map(org => {
							return (
								<Grid item xs={12} sm={12} md={12} lg={12} key={org.uuid}>
									<div onClick={() => navigate("/admin/organisation/" + org.uuid)} key={org.uuid} style={{ cursor: 'pointer' }}>{org.name}</div>
									{org.suborgs.map(suborg => {
										return (
											<div onClick={() => navigate("/admin/organisation/" + suborg.uuid)} key={suborg.uuid} style={{ cursor: 'pointer', marginTop: '10px', marginLeft: '20px' }}>
												{suborg.name}
											</div>
										)
									})}
								</Grid>
							)
						})}
					</Grid>

				</CardContent>
			</Card>
			<Card style={{ marginTop: '20px' }}>
				<CardHeader title="Brugere" 
					action={
						<>
							<AddIcon onClick={() => navigate("/admin/organisation/" + myOrg.uuid + "/adduser")} style={{ cursor: 'pointer', marginRight: '10px' }} />
						</>
					}
				/>
				<CardContent>
					<Grid container spacing={2} style={{ marginTop: '0px' }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							{viewListUsers.map(user => {
								return (
									<div key={user.uuid} onClick={() => navigate("/admin/organisation/" + myOrg.uuid + "/edituser/" + user.uuid)} style={{ cursor: 'pointer', marginBottom: '10px' }}>
										{user.firstName} {user.lastName} - ({user.email})
										<EditIcon onClick={() => navigate("/admin/organisation/" + myOrg.uuid + "/edituser/" + user.uuid)} style={{ cursor: 'pointer', marginLeft: '10px' }} />
									</div>
								)
							})}
						</Grid>
					</Grid>
				</CardContent>
			</Card>
			<Card style={{ marginTop: '20px' }}>
				<CardHeader title="Bygninger & tilhørende enheder"
					action={
						<>
							<AddIcon  onClick={() => navigate("/admin/organisation/" + myOrg.uuid + "/addbuilding")} style={{ cursor: 'pointer', marginRight: '10px' }} />
						</>
					}
				/>
				<CardContent>
					<Grid container spacing={2} style={{ marginTop: '0px' }}>
						{viewListBuildings.map(building => {
							return (
								<Grid item xs={12} sm={12} md={12} lg={12}>
									<div key={building.uuid} onClick={() => navigate("/admin/organisation/" + myOrg.uuid + "/editbuilding/" + building.uuid)} style={{ cursor: 'pointer', marginBottom: '10px' }}>
										{building.name}
										<EditIcon onClick={() => navigate("/admin/organisation/" + myOrg.uuid + "/editbuilding/" + building.uuid)} style={{ cursor: 'pointer', marginLeft: '10px' }} />
									</div>
									{building.devices.map(device => {
										return (
											// onClick={() => navigate('/' + device.uuname.replace('skyen', '') + '/building')} 
											<div key={device.uuid} style={{ cursor: 'pointer', marginLeft: '20px', marginBottom: '5px' }}>
												<a style={{textDecoration: 'none', color: '#000'}} href={`https://dashboard.aabn.io/${device.uuname.replace('skyen', 'sky').toUpperCase()}`} target='_blank' rel='noreferrer'>{device.metadata.title ? `${device.metadata.title}` : device.name} ({device.uuname})</a>
												<EditIcon onClick={() => navigate('/' + device.uuname.replace('skyen', '') + '/building')} style={{ cursor: 'pointer', marginLeft: '10px' }} />
											</div>
										)
									})}
								</Grid>
							)
						})}


					</Grid>
				</CardContent>
			</Card>
		</Container>
		:
		<CircularLoader />
	);
};

export default AdminOrganisation;